import { render, staticRenderFns } from "./VirtualScrollList.vue?vue&type=template&id=5ab48f92&scoped=true"
import script from "./VirtualScrollList.vue?vue&type=script&lang=ts"
export * from "./VirtualScrollList.vue?vue&type=script&lang=ts"
import style0 from "./VirtualScrollList.vue?vue&type=style&index=0&id=5ab48f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab48f92",
  null
  
)

export default component.exports